/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import { css } from "styled-components";
import { Breakpoints } from "../../constants/Breakpoints";

export const createMediaTemplate =
  (breakpoint, isMaxWidth = false) =>
  (...args) =>
    css`
      @media (${isMaxWidth ? "max-width" : "min-width"}: ${breakpoint}) {
        ${css(...args)}
      }
    `;

export const mediaHelper = Object.keys(Breakpoints).reduce((acc, label) => {
  acc[label] = createMediaTemplate(Breakpoints[label]);
  return acc;
}, {});

export const mediaHelperMaxWidth = Object.keys(Breakpoints).reduce(
  (acc, label) => {
    acc[label] = createMediaTemplate(Breakpoints[label], true);
    return acc;
  },
  {}
);
